import React from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { useVerificationStore } from '../../context/VerificationContext';
import { stringifyOptionsArray } from '../../utils/verification/verificationUtils';
import { DropdownWrapper } from '../../styles/panel.style';
import { DropdownsWrapper, FilterPanelWrapper } from '../../pages/verification/Verification.styles';
import { SelectedText } from '../../pages/verification/Verification.styles';
import { useQueryParamsHandler } from 'odfjell-query-manager';
import { Separator } from 'src/App.styles';

const FilterPanelComponent: React.FC = () => {
    const {
        initialSelectedYears,
        selectedYears,
        numFilteredReports,
        selectedReportTypes,
        initialSelectedReportTypes,
        selectedReportStatuses,
        initialSelectedReportStatuses,
        selectedChecks,
        availableChecks,
        setSelectedChecks,
    } = useVerificationStore();

    const { triggerQueryParamsUpdate } = useQueryParamsHandler();

    const onYearsChange = (selectedItems) => {
        let yearsStr = '';

        if (selectedItems.length > 0) {
            yearsStr = stringifyOptionsArray(selectedItems);
        } else {
            yearsStr = 'none';
        }

        triggerQueryParamsUpdate([{ name: 'years', newValue: yearsStr }]);
    };

    const onTypesChange = (selectedItems) => {
        let reportTypesStr = '';

        if (selectedItems.length > 0) {
            reportTypesStr = stringifyOptionsArray(selectedItems);
        } else {
            reportTypesStr = 'none';
        }
        triggerQueryParamsUpdate([{ name: 'reportTypes', newValue: reportTypesStr }]);
    };

    const onStatusChange = (selectedItems) => {
        let reportStatusesStr = '';

        if (selectedItems.length > 0) {
            reportStatusesStr = stringifyOptionsArray(selectedItems);
        } else {
            reportStatusesStr = 'none';
        }

        triggerQueryParamsUpdate([{ name: 'reportStatuses', newValue: reportStatusesStr }]);
    };

    const onChecksChange = (selectedItems) => {
        let checksStr = '';
        if (selectedItems.length === 0) {
            checksStr = 'none';
            setSelectedChecks([]); // explicit none
        } else if (availableChecks && selectedItems.length === availableChecks.length) {
            checksStr = 'all';
            setSelectedChecks(null); // represent all
        } else {
            checksStr = stringifyOptionsArray(selectedItems);
            setSelectedChecks(selectedItems); // subset
        }
        triggerQueryParamsUpdate([{ name: 'checks', newValue: checksStr }]);
    };

    const filterOptions = (options, filter) => {
        if (!filter) {
            return options;
        }
        const re = new RegExp(filter, 'i');
        return options.filter(({ label }) => label && label.match(re));
    };

    return (
        <>
            <FilterPanelWrapper>
                <DropdownsWrapper>
                    <DropdownWrapper>
                        <label>Status</label>
                        <MultiSelect
                            options={initialSelectedReportStatuses}
                            filterOptions={filterOptions}
                            value={selectedReportStatuses}
                            onChange={onStatusChange}
                            labelledBy={'Select'}
                            overrideStrings={{
                                selectSomeItems: 'Select statuses',
                                allItemsAreSelected: 'All statuses',
                                selectAll: 'Select All',
                                search: 'Search',
                            }}
                        />
                    </DropdownWrapper>
                    <DropdownWrapper>
                        <label>Report type</label>
                        <MultiSelect
                            options={initialSelectedReportTypes}
                            filterOptions={filterOptions}
                            value={selectedReportTypes}
                            onChange={onTypesChange}
                            labelledBy={'Select'}
                            overrideStrings={{
                                selectSomeItems: 'Select types',
                                allItemsAreSelected: 'All types',
                                selectAll: 'Select All',
                                search: 'Search',
                            }}
                        />
                    </DropdownWrapper>
                    <DropdownWrapper>
                        <label>DNV issue / warning types</label>
                        <MultiSelect
                            options={availableChecks}
                            filterOptions={filterOptions}
                            value={selectedChecks === null ? availableChecks : selectedChecks}
                            onChange={onChecksChange}
                            labelledBy={'Select'}
                            overrideStrings={{
                                selectSomeItems: 'Select types',
                                allItemsAreSelected: 'All types',
                                selectAll: 'Select All',
                                search: 'Search',
                            }}
                        />
                    </DropdownWrapper>
                    <Separator></Separator>
                    <DropdownWrapper>
                        <label>Year</label>
                        <MultiSelect
                            options={initialSelectedYears}
                            filterOptions={filterOptions}
                            value={selectedYears}
                            onChange={onYearsChange}
                            labelledBy={'Select'}
                            overrideStrings={{
                                selectSomeItems: 'Select years',
                                allItemsAreSelected: 'All years',
                                selectAll: 'Select All',
                                search: 'Search',
                            }}
                        />
                    </DropdownWrapper>
                </DropdownsWrapper>
                <SelectedText>{numFilteredReports} reports selected</SelectedText>
            </FilterPanelWrapper>
        </>
    );
};
export default FilterPanelComponent;
